import axios from "axios"
import { Loading } from "element-ui"
export default {
	namespaced: true,
	state: {
		modules: [],
		settings: {},
		admin_settings: {},
		variables: [[], [], [], [], []],
		permissions: [],
		loading: false,
		msec: 0,
		new_msec: 0,
		lock: false
	},
	getters: {
		modules: state => state.modules,
		permissions: state => state.permissions,
		settings: state => state.settings,
		admin_settings: state => state.admin_settings,
		variables: state => state.variables,
		modules_id: state => {
			var j = {}
			state.modules.forEach(module => (j[module.name] = module.id))
			return j
		},
		loading: state => state.loading,
		msec: state => state.msec,
		new_msec: state => state.new_msec
	},
	mutations: {
		mutate(state, payload, element) {},

		LOAD_MODULES(state, payload) {
			state.modules = payload.modules
		},

		LOAD_SETTINGS(state, payload) {
			var list = payload.settings
			var tmp = {}
			list.forEach(suffix => {
				tmp[suffix.key] = suffix.value
			})
			state.settings = tmp
			state.admin_settings = { ...list }
		},

		LOAD_VARIABLES(state, payload) {
			state.variables = payload
		},
		CHANGE_LOADING(state, payload = 0) {
			state.new_msec = payload
		},
		OPEN_LOADING(state, payload = undefined) {
			if(!state.lock){
				state.loading = true
				state.msec = payload && payload.msec ? payload.msec : 0
			}

			if (payload && payload.lock) state.lock = true

			// state.loading = Loading.service({
			// 	lock: true,
			// 	text: "Loading",
			// 	spinner: "el-icon-loading",
			// 	background: "rgba(0, 0, 0, 0.7)"
			// })
		},
		CLOSE_LOADING(state, removelock = false) {
			if(removelock) state.lock = false
			// state.loading.close()
			//state.loading = undefined
			if(!state.lock){
				state.loading = false
				state.msec = 0
			}
		}
	},
	actions: {
		doModules({ commit }) {
			axios(`${process.env.VUE_APP_API_URL}/api/module`, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
				.then(({ data }) => commit("LOAD_MODULES", data))
				.catch(err => console.error(err))
		},
		doSettings({ commit }) {
			if (localStorage.getItem("JWT")) {
				axios(`${process.env.VUE_APP_API_URL}/api/setting/getall`, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
					.then(({ data }) => commit("LOAD_SETTINGS", data))
					.catch(err => console.error(err))
			}
		},
		doVariables({ commit }) {
			return axios(`${process.env.VUE_APP_API_URL}/api/customfields/getByLevel`, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
				.then(({ data }) => commit("LOAD_VARIABLES", data))
				.catch(err => console.error(err))
		}
	}
}
